import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

require('moment-precise-range-plugin');

@Pipe({
  name: 'minutesToHuman',
})
export class MinutesToHumanPipe implements PipeTransform {
  public transform(minutes: number): string {
    return minutesToHuman(minutes);
  }
}

interface PreciseDiff {
  days: number;
  firstDateWasLater: boolean;
  hours: number;
  minutes: number;
  months: number;
  seconds: number;
  years: number;
}

const dateOrder: (keyof PreciseDiff)[] = ['years', 'months', 'days', 'hours', 'minutes'];

const substitutes: Partial<Record<keyof PreciseDiff, string>> = { months: 'mo' };

export function minutesToHuman(minutes: number): string {
  if (typeof minutes === 'string') {
    return minutes;
  }
  const asMoment = moment().add(minutes, 'minutes');
  if (asMoment.isValid) {
    const preciseDiff: PreciseDiff = (moment as any).preciseDiff(moment(), asMoment, true);
    const result = [];
    let dateOrderIndex = 0;
    while (dateOrderIndex < dateOrder.length && result.length < 2) {
      const key = dateOrder[dateOrderIndex];
      if (preciseDiff[key] > 0) {
        const keyName = substitutes[key] ? substitutes[key] : key.substring(0, 1).toLocaleLowerCase();
        result.push(`${preciseDiff[key]}${keyName}`);
      }
      dateOrderIndex++;
    }
    if (result.length) {
      return `${result.join(' ')}`;
    }
    return '0m';
  }
  return '-';
}

export function minutesToHumanFull(minutesData: number) {
  let days = 0;
  let hours = Math.floor(minutesData / 60);
  const minutes = minutesData % 60;

  if (hours >= 24) {
    days = Math.floor(hours / 24);
  }
  let label = '';
  if (days > 0) {
    let dayUnit = ' day ';
    if (days > 1) {
      dayUnit = ' days ';
    }
    label = days + dayUnit;
    hours = hours % 24;
  }

  if (hours > 0) {
    let hourUnit = ' hour ';
    if (hours > 1) {
      hourUnit = ' hours ';
    }
    label = label + hours + hourUnit;
  }

  if (minutes > 0) {
    let minuteUnit = ' minute';
    if (minutes > 1) {
      minuteUnit = ' minutes';
    }
    label = label + minutes + minuteUnit;
  }

  return label;
}
